import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../predictbook.css";
import styles from '../../styles.module.scss';

import axios from "axios";
import $ from "jquery";

let auto_entry_status = 'not_available';

export const BetSlipTwo = (props) => {
    const dispatch = useDispatch();
    const { racerID, accountAddress, userID, spectatorID, loginToken, loginTime } = useSelector((state) => state.account);
    const { admin_racers, live_hosts } = useSelector((state) => state.app);

    const [pageSet, setPage] = useState(false);
    const [entryButton, setEntryButton] = useState('');
    const [entryStatus, setEntryStatus] = useState('');
    const [entryName, setEntryName] = useState('');
    const [racesUsed, setRacesUsed] = useState('');
    const [racesMin, setRacesMin] = useState('');
    const [racesMax,setRacesMax] = useState('');

    function grabAutoEntryStatus() {
        loadAutoEntryBanner([]);
    }

    function loadAutoEntryBanner(infoarr) {
        var tmp_collection_name = '';
        var racesused = 0;
        var racesmin = 0;
        for(var i = 0; i < infoarr.length;i++) {
            tmp_collection_name = infoarr[i]['race_collection_name'];

            var open_races_used = infoarr[i]['open_races_used'];
            var open_races_max = infoarr[i]['open_races_max'];
            var auto_open_races_max = infoarr[i]['auto_open_races_max'];

            racesused = open_races_used;
            racesmin = auto_open_races_max;
            setRacesUsed(open_races_used);
            setRacesMin(auto_open_races_max);
            setRacesMax(open_races_max);
            
            var auto_entry_flag = infoarr[i]['racer_auto_entry_flag'];
            var auto_entry_active = infoarr[i]['auto_entry_active_flag'];
            var race_group_collection_id = infoarr[i]['race_group_collection_id'];
            
            var pilot_item_id = infoarr[i]['pilot_item_id'];
            var racecraft_item_id = infoarr[i]['racecraft_item_id'];
            var booster_item_id = infoarr[i]['booster_item_id'];

            if(open_races_used >= auto_open_races_max) {
                auto_entry_status = 'maxed_out';
            } else if(auto_entry_flag == 1) {
                if(auto_entry_active == 1) {
                    auto_entry_status = 'auto_entry_on';
                } else {
                    auto_entry_status = 'auto_entry_off';
                }
            } else {
                auto_entry_status = 'auto_entry_off';
            }
        }

        var entrybuttonhtml = <span className="round-border-button-grey" style={{fontSize:'18px',maxWidth:'250px'}} title="Auto Entry Not Available">
                                        NOT AVAILABLE
                                </span>;
        var entrystatushtml = <span className="white-text" title="Auto Entry Not Available">
                                    Not Available
                            </span>;
        if(auto_entry_status == 'auto_entry_on') {
            entrybuttonhtml = <span className="round-border-button" style={{fontSize:'18px'}} title="Turn Off Auto Entry" onClick={()=>toggleAutoEntry('off')}>
                                        TURN OFF
                                    </span>;
            entrystatushtml = <span className="exr-light-green-text" title="Auto Entry is On">
                                        Auto-Entry On // {racesmin - racesused} Auto Races Left
                                </span>;
        } else if(auto_entry_status == 'auto_entry_off') {
            entrybuttonhtml = <span className="round-border-button" style={{fontSize:'18px'}} title="Turn On Auto Entry" onClick={()=>toggleAutoEntry('on')}>
                                        TURN ON
                                    </span>;
            entrystatushtml = <span className="white-text" title="Auto Entry is Off">
                                        Auto-Entry Off // {racesmin - racesused} Auto Races Left
                                </span>;
        } else if(auto_entry_status == 'maxed_out') {
            entrybuttonhtml = <span className="round-border-button-grey" style={{fontSize:'18px'}} title="Auto Entry Maxed Out">
                                        NOT AVAILABLE
                                </span>;
            entrystatushtml = <span className="white-text" title="Auto Entry Not Available">
                                    Races Maxed Out // {racesused} Races Run
                            </span>;
        }

        setEntryName(tmp_collection_name);
        setEntryButton(entrybuttonhtml);
        setEntryStatus(entrystatushtml);
    }

    function toggleAutoEntry(switchtype) {
        var addData = new Object();
        addData.racerID = encodeURIComponent(racerID);
        addData.collectionID = encodeURIComponent(props.collectionID);

        var switch_location = 'member/race_auto_entry_on/';
        if(switchtype == 'off') {
            switch_location = 'member/race_auto_entry_off/';
        }

        var entrybuttonhtml = <div id="autoentryloading" className="preloader-wrapper small active center-align">
                                    <div className="spinner-layer spinner-red-only">
                                        <div className="circle-clipper left">
                                            <div className="circle"></div>
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle"></div>
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle"></div>
                                        </div>
                                    </div>
                                </div>;
        setEntryButton(entrybuttonhtml);
    }

    if(pageSet == false) {
        setPage(true);
    }

    return(<div className="col s12 white-text" style={{padding:'0px'}}>
            <div className="row exr-new-light-grey" style={{margin:'0px',marginTop:'0px 20px',padding:'5px 0px 2.5px',borderRadius:'10px',marginBottom:'20px'}}>
                <div className="col s12 m8" style={{padding:'0px 5px',marginBottom:'5px',fontSize:'14px'}}>
                    <div className="row exr-new-light-grey" style={{margin:'5px',marginBottom:'0px',fontSize:'14px',padding:'10px 10px 5px',lineHeight:'1',borderRadius:'10px'}}>
                        <div className="col s12" style={{margin:'0px',fontSize:'14px',padding:'5px',lineHeight:'1',borderBottom:'1px solid #EBEBEB'}}>
                            <div className="col s12 l6 headline-text" style={{padding:'0px'}}>RACE #12345</div>
                            <div className="col s12 l6 right-align" style={{padding:'0px'}}>TIME LEFT: 25m 44s</div>
                        </div>
                        <div className="col s12" style={{margin:'0px',fontSize:'14px',padding:'10px 0px 5px',lineHeight:'1',borderBottom:'1px solid #EBEBEB'}}>
                            <div className="row" style={{margin:'0px',marginBottom:'5px'}}>
                                <div className="col s12 m6 l4" style={{padding:'0px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'2.5px',fontSize:'12px',padding:'10px',lineHeight:'1',borderRadius:'10px'}}>
                                        RACER 1 
                                    </div>
                                </div>
                                <div className="col s12 m6 l4" style={{padding:'0px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'2.5px',fontSize:'12px',padding:'10px',lineHeight:'1',borderRadius:'10px'}}>
                                        RACER 2 
                                    </div>
                                </div>
                                <div className="col s12 m6 l4" style={{padding:'0px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'2.5px',fontSize:'12px',padding:'10px',lineHeight:'1',borderRadius:'10px'}}>
                                        RACER 3 
                                    </div>
                                </div>
                                <div className="col s12 m6 l4" style={{padding:'0px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'2.5px',fontSize:'12px',padding:'10px',lineHeight:'1',borderRadius:'10px'}}>
                                        RACER 4 
                                    </div>
                                </div>
                                <div className="col s12 m6 l4" style={{padding:'0px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'2.5px',fontSize:'12px',padding:'10px',lineHeight:'1',borderRadius:'10px'}}>
                                        RACER 5 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col s12" style={{margin:'2.5px 0px',fontSize:'14px',padding:'10px 10px 5px',lineHeight:'1'}}>
                            <div className="col s12 l6" style={{padding:'0px'}}>5 LAPS // STANDARD RACE</div>
                            <div className="col s12 l6 right-align" style={{padding:'0px'}}>
                                <span className="right round-border-button" style={{fontSize:'10px',height:'20px',marginTop:'-2px'}}>
                                    VIEW DETAILS
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col s12 m4" style={{margin:'0px',padding:'5px 10px',marginBottom:'5px',fontSize:'14px'}}>
                    <div className="row exr-stats-light-grey" style={{height:'175px',margin:'0px',marginBottom:'0px',fontSize:'14px',padding:'10px 10px 5px',lineHeight:'1',borderRadius:'10px'}}>
                        <div className="col s12 headline-text" style={{margin:'0px',fontSize:'14px',padding:'10px 10px 5px',lineHeight:'1',borderBottom:'1px solid #EBEBEB'}}>
                            <div className="col s12" style={{padding:'0px'}}>YOUR PICK</div>
                        </div>
                        <div className="col s12" style={{margin:'0px',fontSize:'14px',padding:'10px 0px 5px',lineHeight:'1',borderBottom:'1px solid #EBEBEB'}}>
                            <div className="row" style={{margin:'0px',marginBottom:'5px'}}>
                                <div className="col s12" style={{padding:'0px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'2.5px',marginBottom:'2.5px',fontSize:'12px',padding:'10px',lineHeight:'1',borderRadius:'10px'}}>
                                        <div className="col s12 l6" style={{padding:'0px'}}>1ST // RACER 1</div>
                                        <div className="col s12 l6 right-align" style={{padding:'0px'}}>78% WIN</div>
                                    </div>
                                </div>
                                <div className="col s12 m6" style={{padding:'0px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'2.5px',marginBottom:'2.5px',fontSize:'12px',padding:'10px',lineHeight:'1',borderRadius:'10px'}}>
                                        <div className="col s12 l6" style={{padding:'0px'}}>FREE WIN</div>
                                        <div className="col s12 l6 right-align" style={{padding:'0px'}}>23 XP</div>
                                    </div>
                                </div>
                                <div className="col s12 m6" style={{padding:'0px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'2.5px',marginBottom:'2.5px',fontSize:'12px',padding:'10px',lineHeight:'1',borderRadius:'10px'}}>
                                        <div className="col s12 l6" style={{padding:'0px'}}>PAID WIN</div>
                                        <div className="col s12 l6 right-align" style={{padding:'0px'}}>$25 USDC*</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col s12" style={{margin:'2.5px 0px',fontSize:'14px',padding:'10px 10px 5px',lineHeight:'1'}}>
                            <div className="col s12 l6" style={{padding:'0px'}}></div>
                            <div className="col s12 l6 right-align" style={{padding:'0px'}}>
                                <span className="right round-border-button" style={{fontSize:'10px',height:'20px',marginTop:'-5px'}}>
                                    MAKE PICK
                                </span>
                            </div>
                        </div>
                </div>
                </div>
            </div>
        </div>);
};